import { EllipsisHorizontalIcon } from "@heroicons/react/20/solid";
import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../../api";
import {
  Dropdown,
  DropdownButton,
  DropdownItem,
  DropdownMenu,
} from "../../../externalComponents/tailwind/dropdown";
import { getAutomationStatus } from "../helpers/functions";
import { mappingAutomationTypeWithField } from "./mapping-automation-type-with-field.const";

const AutomationActionsDropdown = ({ automation, customerId, setListData }) => {
  const navigate = useNavigate();

  const handleArchiverClick = useCallback((selectedCampaign) => {
    setListData((_listData) => ({
      ..._listData,
      selectedCampaign,
      isModalOpen: true,
    }));
  }, []);

  const handleDuplicateClick = useCallback((selectedCampaign) => {
    setListData((_listData) => ({
      ..._listData,
      selectedCampaign,
      isModalDuplicateOpen: true,
    }));
  }, []);

  const handleShareClick = useCallback((selectedCampaign) => {
    setListData((_listData) => ({
      ..._listData,
      selectedCampaign,
      isModalShareOpen: true,
    }));
  }, []);

  const { isAutomationActive } = useMemo(
    () => getAutomationStatus(automation),
    [automation],
  );

  return (
    <Dropdown>
      <DropdownButton plain aria-label="More options">
        <EllipsisHorizontalIcon />
      </DropdownButton>

      <DropdownMenu anchor="bottom end">
        <DropdownItem onClick={() => navigate(`/analytics/${automation.id}`)}>
          Analytics
        </DropdownItem>
        {automation.automationType === "back-in-stock" && (
          <DropdownItem
            onClick={() => navigate("/automations/back-in-stock-alerts")}
          >
            View alerts
          </DropdownItem>
        )}
        <DropdownItem
          onClick={() => navigate(`/automations/edit/${automation.id}`)}
        >
          Edit
        </DropdownItem>
        <DropdownItem onClick={() => handleDuplicateClick(automation)}>
          Duplicate
        </DropdownItem>

        <DropdownItem
          onClick={async () => {
            if (
              !["api", "klaviyo", "splio"].includes(automation.automationType)
            ) {
              await api.customer.update(customerId, {
                [mappingAutomationTypeWithField[automation.automationType]]:
                  isAutomationActive ? null : { _link: automation.id },
              });
            }
            if (
              !isAutomationActive &&
              (automation.automationType === "abandoned-cart" ||
                automation.automationType === "just-abandoned-checkout")
            ) {
              try {
                const scenario = await api.scenario.findFirst({
                  filter: {
                    customerId: {
                      equals: customerId,
                    },
                    campaignId: {
                      equals: automation.id,
                    },
                  },
                  select: {
                    id: true,
                  },
                });
                const flowNode = await api.flowNode.maybeFindFirst({
                  filter: {
                    scenarioId: {
                      equals: scenario.id,
                    },
                    type: {
                      equals: "automation_trigger",
                    },
                    customerId: {
                      equals: customerId,
                    },
                  },
                });
                if (flowNode) {
                  api.customer.update(customerId, {
                    abandonedCartDelayInMinutes:
                      flowNode.abandonedCartDelayInMinutes,
                  });
                }
              } catch (e) {
                console.error(e);
              }
            }
            await api.campaign.update(automation.id, {
              isAutomationActive: !isAutomationActive,
            });
          }}
        >
          {isAutomationActive ? "Turn off" : "Turn on"}
        </DropdownItem>

        <DropdownItem onClick={() => handleShareClick(automation)}>
          Share
        </DropdownItem>
        <DropdownItem onClick={async () => handleArchiverClick(automation)}>
          Archive
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  );
};

export default AutomationActionsDropdown;
